import { userService } from "../../service/index.js";
import { router } from "../../router.js";
import i18n from "../../i18n.js";

import { ServiceClient } from "../../service_client/service_client.js";

import * as MyFilters from "../../components/products/filters.js";

const user = JSON.parse(sessionStorage.getItem("user"));
const state = user ? { status: { loggedIn: true }, user, message: {} } : { status: {}, user: null, message: null };

const actions = {
  login({ dispatch, commit }, { username, password, serverIP }) {
    commit("loginRequest", { username });
    userService.login(username, password, serverIP).then(
      (user) => {
        commit("loginSuccess", user);

        let l = JSON.parse(sessionStorage.getItem("user"));

        ServiceClient.dataCore(ServiceClient.getAPIUrl("point"), null, null, "GET")
          .then((data) => {
            let type;

            if ("type" in data) {
              type = data.type;
              // Vuex - Point - updateType
              dispatch("point/updateType", type, { root: true });
            } else {
              type = "";
              // Vuex - Point - updateType
              dispatch("point/updateType", type, { root: true });
            }

            if ("projectName" in data) {
              dispatch("point/updateProjectName", data.projectName, { root: true });
            }
            if ("objectName" in data) {
              dispatch("point/updateObjectName", data.objectName, { root: true });
            }
            if ("sn" in data) {
              dispatch("point/updateSerialNumber", data.sn, { root: true });
            }

            if (type === MyFilters.type[0]) {
              router.push(`/${i18n.locale}/evcs-dashboard`);
            } else if (type === MyFilters.type[1]) {
              router.push(`/${i18n.locale}/eess-basic`);
            } else if (type === MyFilters.type[2]) {
              router.push(`/${i18n.locale}/escb-dashboard`);
            } else {
              router.push(`/${i18n.locale}/products`);
            }
          })
          .catch((error) => {
            ServiceClient.handleUnauthorized(error, this.$router);

            if ("roles" in l) {
              if (l.roles.includes("EVC_ADMIN") || l.roles.includes("EVC_SERVICE") || l.roles.includes("EVC_USER")) {
                router.push(`/${i18n.locale}/evcs-dashboard`);
              } else if (l.roles.includes("EC_ADMIN") || l.roles.includes("EC_SERVICE") || l.roles.includes("EC_USER")) {
                router.push(`/${i18n.locale}/eess-basic`);
              } else {
                router.push(`/${i18n.locale}/products`);
              }
            }
          });
      },
      (error) => {
        commit("loginFailure", error);

        if (!(typeof error === "number" && isFinite(error))) {
          error = "unknown";
        }

        dispatch("alert/error", i18n.t("login.returnCodes." + error.toString()), { root: true });
      }
    );
  },
  logout({ commit }) {
    userService.logout();
    commit("logout");
  },
};

const mutations = {
  loginRequest(state, user) {
    state.status = { loggingIn: true };
    state.user = user;
  },
  loginSuccess(state, user) {
    state.status = { loggedIn: true };
    state.user = user;
  },
  loginFailure(state) {
    state.status = {};
    state.user = null;
  },
  logout(state) {
    state.status = {};
    state.user = null;
  },
};

export const account = {
  namespaced: true,
  state,
  actions,
  mutations,
};
